<template>
  <div class="main">
    <div class="row g-5">
      <div class="col-md-4 d-none d-md-block">
        <div class="position-sticky " style="top: 80px;">
          <div class="p-4 mb-3 bg-light rounded">
            <h5 class="fst-italic">关于我们</h5>
            <p class="mb-0">每一个人，都可以将自己的兴趣，知识以笔记的形式记录下来，可以当作个人的记事本，也可以分享给大家。</p>
          </div>
          <div class="p-4">
            <h5 class="fst-italic">分类</h5>
            <ul class="nav flex-column">
              <li class="nav-item" v-for="item in menulist" :key="item.id">
                <a class="nav-link p-2 text-muted " :class="[item.id === $store.state.listcategory ? 'activeLink' : '']"
                  v-on:click="toCategory(item.id, item.title)" exact>{{
                item.title }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <ul class="nav flex-row  d-md-none">
          <li class="nav-item" v-for="item in menulist" :key="item.id">
            <a class="nav-link p-1 text-muted " :class="[item.id === $store.state.listcategory ? 'activeLink' : '']"
              v-on:click="toCategory(item.id, item.title)" exact>{{
                item.title }}</a>
          </li>
        </ul>
        <div v-for="item in docIndex" :key="item.id">
          <nav aria-label="breadcrumb" class="d-none d-md-block">
            <ol class="breadcrumb">
              <li class="breadcrumb-item active" aria-current="page">{{ item.title }}</li>
            </ol>
          </nav>
          <ul class="list-unstyled">
            <li class="border-bottom alert alert-light" v-on:click="toDetails(menuitem.id)"
              v-for="menuitem in item.menuitems" :key="menuitem.id">
              <div class="media pb-3 round">
                <h6 class="mt-0 mb-1 fw-semibold text-info-emphasis">{{ menuitem.title }}
                </h6>
                <div class="text-body ">
                  <small v-if="menuitem.subtitle">{{ menuitem.subtitle }}</small>
                  <p class="mb-1 fw-light"><small :title='menuitem.preface'>{{ menuitem.preface2 }}</small></p>
                </div>
                <div class="text-body-tertiary "><small class="pull-left ">{{ menuitem.dt }}</small> <small
                    class="pull-right" v-html="menuitem.tags"></small></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

// Import jquery
import $ from 'jquery'
import sx from "../utils/core.js";
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      tags: '',
      doc: {},
      gallery: [],
      meta: {},
      menulist: [{ title: "产品文档", id: "14" }, { title: "营销文案", id: "15" }, { title: "解决方案", id: "16" }, { title: "学习笔记", id: "17" }, { title: "攻略指南", id: "18" }, { title: "归纳总结", id: "24" }],
      docIndex: []
    };
  },
  watch: {
  },
  mounted() {
    const that = this;
    document.title = "guavaslink"
    that.preInit();
  },
  methods: {
    toCategory(category, catename) {
      const that = this
      that.$store.state.listcategory = category;
      that.$store.state.listcatename = catename;
      that.preInit();
    },
    toDetails(id) {
      const that = this
      that.$router.push({ name: 'Details', params: { docid: id } })
    },
    preInit() {
      const that = this;
      const mymodal = sx.showWaiting()
      var params = {
        bucketid: "13",
        categorylist: JSON.stringify([that.$store.state.listcategory]),
        token: localStorage.getItem("token") || "token"
      }
      var url = that.$store.state.baseurl + '/app/cmshelper/fetchDocIndex'
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === 'ok') {
            that.docIndex = []
            for (const key in result.data.docIndex) {
              var items = result.data.docIndex[key]
              var menuitems = []
              var menutitle = ""
              $.each(items, function (idx, item) {
                var menuurl = require("../assets/img_3.jpg")
                var meta = JSON.parse(item[10] || "{}")
                if (meta.gallery && meta.gallery.length > 0) {
                  menuurl = 'https://cloud.salesmini.cn' + meta.gallery[0]
                }
                menuitems.push({
                  id: item[14],
                  title: item[1],
                  subtitle: item[4],
                  dt: item[12],
                  tags: sx.gethtmltags(item[3]),
                  preface: item[5],
                  preface2: sx.substring(item[5], 100, "..."),
                  url: menuurl
                })
                menutitle = item[13]
              });
              that.docIndex.push({
                id: key,
                title: menutitle,
                menuitems: menuitems
              })
            }
            sx.hideWaiting(mymodal)
          } else {
            sx.toastSuccess(result.message)
            console.log(result.message)
            sx.hideWaiting(mymodal)
          }
        },
        function () {
          sx.login(
            url,
            params,
            function (result) {
              if (result.status === 'ok') {
                that.docIndex = []
                for (const key in result.data.docIndex) {
                  var items = result.data.docIndex[key]
                  var menuitems = []
                  var menutitle = ""
                  $.each(items, function (idx, item) {
                    var menuurl = require("../assets/img_3.jpg")
                    var meta = JSON.parse(item[10] || "{}")
                    if (meta.gallery && meta.gallery.length > 0) {
                      menuurl = 'https://cloud.salesmini.cn' + meta.gallery[0]
                    }
                    menuitems.push({
                      id: item[14],
                      title: item[1],
                      subtitle: item[4],
                      dt: item[12],
                      tags: sx.gethtmltags(item[3]),
                      preface: item[5],
                      preface2: sx.substring(item[5], 100, "..."),
                      url: menuurl
                    })
                    menutitle = item[13]
                  });
                  that.push({
                    id: key,
                    title: menutitle,
                    menuitems: menuitems
                  })
                }
                sx.hideWaiting(mymodal)
              } else {
                sx.toastError(that.$t('lang.error.failedRequest', { err: result.message }));
              }
            }
          )
        }
      )
      sx.hideWaiting()
    }
  }
}
</script>
<style>
.custom-tag {
  background-color: #e2e6dc;
  padding: 4px 6px 4px 6px;
  border-radius: 4px;
  margin-right: 4px;
}

.subtitle {
  color: #909399
}

.activeLink {
  font-size: large;
  font-weight: bold;
  color: #0dcaf0 !important;
}

.nav-link {
  cursor: pointer;
}

.media {
  cursor: pointer;
}
</style>
